<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.pwa_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.pwa_ym" slot="pwa_ym">
            <label class="weui-form-preview__label">{{customLabel.pwa_ym || "调整账期"}}</label>
            <span class="weui-form-preview__value">{{form.main.pwa_ym}}</span>
          </div>
          <!-- <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" /> -->
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.pwd_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{item.pr_code}} {{item.pr_detail}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{item.pr_spec}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{item.pr_brand}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pwd_whname">
              <label class="weui-form-preview__label">{{customLabel.pwd_whname || "仓库"}}</label>
              <span class="weui-form-preview__value">{{item.pwd_whname}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pwd_amount">
              <label class="weui-form-preview__label">{{customLabel.pwd_amount || "调整金额"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.pwd_amount,'#,##0.####')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pwd_oldamount">
              <label class="weui-form-preview__label">{{customLabel.pwd_oldamount || "调整前原金额"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.pwd_oldamount,'#,##0.00')}}</span>
            </div>
            <div class="weui-form-preview__item" slot="pwd_oldqty">
              <label class="weui-form-preview__label">{{customLabel.pwd_oldqty || "调整前原数量"}}</label>
              <span class="weui-form-preview__value">{{item.pwd_oldqty}} {{ item.pr_unit }}</span>
            </div>
            <!-- <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
              v-model="item.pd_text1" slot="pd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
              v-model="item.pd_text2" slot="pd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
              v-model="item.pd_text3" slot="pd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
              v-model="item.pd_text4" slot="pd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
              v-model="item.pd_text5" slot="pd_text5" hidden="true" /> -->
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.pwa_remark}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/adjust_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
// import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout
    // CustomField
  },
  data() {
    return {
      baseUrl: "/api/storage/productwhmonthadjust",
      codeField: "pwa_code",
      statusField: "pwa_statuscode",
      caller: "ProductWhMonthAdjust",
      xtype: "stock-productwhmonthadjust-formpanel",
    };
  }
};
</script>